
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { EnumProductTypeQuery, EnumProductType, EnumContentType, EnumContentTypeText, EnumProductUnit } from '@xt/client/enums'
import LazyImg from '@/components/lazyImg/index.vue'
import { AjaxBasics } from '@xt/client'

@Component({
  components: {
    LazyImg
  }
})
export default class CourseCard extends Vue {
  @Prop() dataSource: {
    coverUrl: string
    productName: string
    learnStartTime: number
    learnEndTime: number
    voteStartTime: number
    voteEndTime: number
    formalEndTime: number
    mainType: number
    taskSchedule: number
    productType: number
    contentType: number
    bizProdCount: number
  }

  // 展览课并且已结束时，隐藏总关数
  get isExhibitionLearnEnd() {
    let currentTime = AjaxBasics.serviceDate.utcOffset(+8).valueOf()
    return this.type == EnumProductTypeQuery.Exhibition && currentTime > this.dataSource.voteEndTime
  }

  /** 当前的课程数量 **/
  get count() {
    return this.dataSource.bizProdCount ? this.dataSource.bizProdCount : 0
  }

  get btnText() {
    if (this.type == EnumProductTypeQuery.Exhibition) {
      let currentTime = AjaxBasics.serviceDate.utcOffset(+8).valueOf()
      if (currentTime < this.dataSource.voteStartTime) {
        return '去备展'
      }
      return '去观展'
    }
    return '去学习'
  }

  /** 当前的课程类型 **/
  get type() {
    if (this.dataSource.productType == EnumProductType.fullstage || this.dataSource.productType == EnumProductType.single) {
      return EnumProductTypeQuery.Course
    } else if (this.dataSource.productType == EnumProductType.dayCourse || this.dataSource.productType === EnumProductType.selfStudy) {
      return EnumProductTypeQuery.DayCourse
    } else {
      return EnumProductTypeQuery.Exhibition
    }
  }

  //展览辅导课
  get exhibitionState() {
    let currentTime = AjaxBasics.serviceDate.utcOffset(+8).valueOf()
    if (currentTime > this.dataSource.voteEndTime) return '投票结束'
    if (currentTime > this.dataSource.voteStartTime) return '正在投票'
    if (currentTime > this.dataSource.formalEndTime) return '备展结束'
    if (this.dataSource.mainType === 1 || this.dataSource.mainType === 2)
      return this.dataSource.taskSchedule !== 0 ? `进行至第${this.dataSource.taskSchedule}关` : '选择临摹习作'
    if (this.dataSource.mainType === 3) return '练习习作提交'
    return '正式习作提交'
  }

  /**
   * 课程的进行状态
   * **/
  get coursePrograss() {
    let currentTime = AjaxBasics.serviceDate.utcOffset(+8).valueOf()
    let courseText = {
      mainText: '',
      subText: ''
    }
    //当前时间小于学习开始时间,未开课
    if (currentTime < this.dataSource.learnStartTime) {
      courseText = {
        mainText: '即将开课',
        subText: `共${this.count + this.unit}`
      }
    }
    //进行中
    else if (currentTime > this.dataSource.learnStartTime && currentTime < this.dataSource.learnEndTime) {
      const updateIndex = this.classhourUpdateIndex === 0 ? 1 : this.classhourUpdateIndex

      courseText = {
        mainText: `进行至第${updateIndex + this.unit}`,
        subText: `共${this.count + this.unit}`
      }
    }
    //已结课
    else {
      courseText = {
        mainText: `已结课`,
        subText: `共${this.count + this.unit}`
      }
    }
    return courseText
  }

  /** 当前的关卡进度 **/
  get classhourUpdateIndex() {
    return this.dataSource.taskSchedule
  }

  get EnumProductTypeQuery() {
    return EnumProductTypeQuery
  }

  /** 当前的课程内容类型 **/
  get contentType() {
    // 1 书法课，2读书课，3写作课，4养生课，5国画课，6实物商品，7书画课，8美育
    switch (this.dataSource.contentType) {
      case EnumContentType.Painting:
        return EnumContentTypeText.Painting
      case EnumContentType.Calligraphy:
        return EnumContentTypeText.Calligraphy
      case EnumContentType.CalligraphyAndReading:
        return EnumContentTypeText.CalligraphyAndReading
      case EnumContentType.Health:
        return EnumContentTypeText.Health
      case EnumContentType.Physical:
        return EnumContentTypeText.Physical
      case EnumContentType.Reading:
        return EnumContentTypeText.Reading
      case EnumContentType.Writing:
        return EnumContentTypeText.Writing
      case EnumContentType.AestheticEducation:
        return EnumContentTypeText.AestheticEducation
      default:
        return EnumContentTypeText.Calligraphy
    }
  }

  /** 当前的课程单位 **/
  get unit() {
    switch (this.type) {
      case EnumProductTypeQuery.Course:
        return EnumProductUnit.LiveCourseCountUnit
      case EnumProductTypeQuery.DayCourse:
        return EnumProductUnit.DayCourseCountUnit
      case EnumProductTypeQuery.Exhibition:
        return EnumProductUnit.ExhibitonCourseCountUnit
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
